import { Component, input } from '@angular/core';

@Component({
  selector: 'app-page-shell',
  templateUrl: './page-shell.html',
  styleUrl: './page-shell.scss',
})
export class PageShell {
  readonly title = input.required<string>();
  readonly description = input<string>('');
  readonly badge = input<string>('');
}
